// extracted by mini-css-extract-plugin
module.exports = {"parallaxBlock":"parallax-block_parallaxBlock__sqf74"};